var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleAuditoriumEssentia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 313.805,
    height: 100,
    viewBox: "0 0 313.805 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_25",
    "data-name": "Ret\\xE2ngulo 25",
    width: 313.805,
    height: 70.3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c79e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0d0a2",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1826",
    "data-name": "Grupo 1826",
    transform: "translate(-1074 -3643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(1074 3672.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    "data-name": "Caminho 722",
    d: "M17.472,8.031l6.519,17.576H10.952ZM13.664,2.868,0,37.655H6.676l2.555-6.676H25.712l2.556,6.676h6.676L21.279,2.868Z",
    transform: "translate(0 -2.294)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_723",
    "data-name": "Caminho 723",
    d: "M185.9,2.868h6.154V23.73c0,5.528,3.077,9.127,8.918,9.127,5.789,0,8.866-3.6,8.866-9.127V2.868H216V23.886c0,8.658-4.955,14.395-15.021,14.395-10.118,0-15.073-5.789-15.073-14.342Z",
    transform: "translate(-148.718 -2.294)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_724",
    "data-name": "Caminho 724",
    d: "M373.372,2.868h12.934c10.848,0,18.2,7.2,18.2,17.42s-7.354,17.367-18.2,17.367H373.372Zm12.934,29.415c7.562,0,11.943-5.424,11.943-12,0-6.728-4.172-12.048-11.943-12.048h-6.832V32.283Z",
    transform: "translate(-298.689 -2.294)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_22",
    "data-name": "Ret\\xE2ngulo 22",
    width: 6.102,
    height: 34.787,
    transform: "translate(111.711 0.574)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M625.344,8.241H614.809V2.869h27.173V8.241H631.446V37.656h-6.1Z",
    transform: "translate(-491.833 -2.295)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    "data-name": "Caminho 726",
    d: "M779.911,0C790.341,0,797.7,7.614,797.7,17.993s-7.354,17.993-17.785,17.993-17.785-7.614-17.785-17.993S769.48,0,779.911,0m0,5.424c-7.041,0-11.526,5.372-11.526,12.569,0,7.145,4.485,12.569,11.526,12.569,6.989,0,11.526-5.424,11.526-12.569,0-7.2-4.538-12.569-11.526-12.569",
    transform: "translate(-609.683)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_727",
    "data-name": "Caminho 727",
    d: "M981.564,24.669h-6.05V37.656h-6.1V2.869h15.281c6.884,0,11.37,4.485,11.37,10.9,0,6.206-4.068,9.544-8.241,10.222l8.5,13.665h-7.041Zm2.295-16.429h-8.345V19.3h8.345c3.442,0,5.946-2.19,5.946-5.528s-2.5-5.528-5.946-5.528",
    transform: "translate(-775.507 -2.295)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_23",
    "data-name": "Ret\\xE2ngulo 23",
    width: 6.102,
    height: 34.787,
    transform: "translate(226.657 0.574)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_728",
    "data-name": "Caminho 728",
    d: "M1200.681,2.868h6.154V23.73c0,5.528,3.077,9.127,8.918,9.127,5.789,0,8.866-3.6,8.866-9.127V2.868h6.154V23.886c0,8.658-4.955,14.395-15.021,14.395-10.118,0-15.073-5.789-15.073-14.342Z",
    transform: "translate(-960.517 -2.294)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_729",
    "data-name": "Caminho 729",
    d: "M1418.191,11.317,1407.5,37.655h-2.608l-10.64-26.338V37.655h-6.1V2.868h8.605l9.44,23.417,9.492-23.417h8.606V37.655h-6.1Z",
    transform: "translate(-1110.488 -2.295)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    "data-name": "Caminho 730",
    d: "M11.8,240.777H26.408v2.869H15.061V250H26.18v2.869H15.061v6.782H26.408v2.869H11.8Z",
    transform: "translate(-9.44 -192.616)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M131.188,255.645a9.17,9.17,0,0,0,6.847,3.065c3.521,0,4.76-1.793,4.76-3.358,0-2.282-2.478-2.935-5.249-3.652-3.489-.913-7.532-1.924-7.532-6.358,0-3.587,3.163-6.2,7.695-6.2a10.661,10.661,0,0,1,7.923,3.032l-1.891,2.413a8.484,8.484,0,0,0-6.293-2.543c-2.413,0-4.076,1.239-4.076,3.065,0,1.956,2.347,2.576,5.054,3.261,3.554.945,7.695,2.054,7.695,6.684,0,3.391-2.347,6.554-8.217,6.554a11.129,11.129,0,0,1-8.575-3.456Z",
    transform: "translate(-103.46 -191.312)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M258.17,255.645a9.17,9.17,0,0,0,6.847,3.065c3.521,0,4.76-1.793,4.76-3.358,0-2.282-2.478-2.935-5.249-3.652-3.489-.913-7.532-1.924-7.532-6.358,0-3.587,3.163-6.2,7.695-6.2a10.661,10.661,0,0,1,7.923,3.032l-1.891,2.413a8.483,8.483,0,0,0-6.293-2.543c-2.413,0-4.076,1.239-4.076,3.065,0,1.956,2.347,2.576,5.054,3.261,3.554.945,7.695,2.054,7.695,6.684,0,3.391-2.347,6.554-8.217,6.554a11.129,11.129,0,0,1-8.575-3.456Z",
    transform: "translate(-205.043 -191.312)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M389.978,240.777h14.607v2.869H393.238V250h11.119v2.869H393.238v6.782h11.347v2.869H389.978Z",
    transform: "translate(-311.973 -192.616)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M517.45,245.831v16.694h-3.261V240.777h3.358l11.836,16.3v-16.3h3.26v21.748h-3.163Z",
    transform: "translate(-411.34 -192.616)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    "data-name": "Caminho 735",
    d: "M660.961,243.646h-6.749v-2.869h16.727v2.869h-6.717v18.879h-3.261Z",
    transform: "translate(-523.355 -192.616)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_24",
    "data-name": "Ret\\xE2ngulo 24",
    width: 3.261,
    height: 21.748,
    transform: "translate(157.137 48.161)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    "data-name": "Caminho 736",
    d: "M861.753,258.025H851.091l-1.761,4.5h-3.587l8.64-21.748h4.076l8.641,21.748h-3.587Zm-9.716-2.9h8.771l-4.4-11.51Z",
    transform: "translate(-676.576 -192.616)",
    fill: "#161615"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_35",
    "data-name": "Ret\\xE2ngulo 35",
    width: 309,
    height: 5,
    transform: "translate(1074 3643)",
    opacity: 0.717,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleAuditoriumEssentia);
export default __webpack_public_path__ + "static/media/title-auditorium-essentia.7fc4e0a7e1562598f80c1be74d1d1100.svg";
export { ForwardRef as ReactComponent };